export default __webpack_public_path__ + "61dd7c4f0119d0580cdd2403baf34245.svg";